<!--<template>-->
<!--&lt;!&ndash;  <NuxtLayout >&ndash;&gt;-->
<!--    <LayoutMain></LayoutMain>-->
<!--&lt;!&ndash;  </NuxtLayout>&ndash;&gt;-->
<!--</template>-->
<!--<script lang="ts" setup>-->

<!--definePageMeta({-->
<!-- middleware: ['router-auth']-->
<!--});-->


<!--</script>-->
<!--<style lang="scss">-->

<!--</style>-->
<template>
  <div>

    <!-- Desktop -->

    <MainNav :logged-in="loggedIn" @login="toggleLoginModal()"></MainNav>


    <!-- Mobile -->
    <div class="d-xl-none sticky-menu element-background-color" style="padding: 8px 16px;">

      <div v-if="showMenu" style="height: 99vh; width: 96%; position: fixed; top: 50px; left: 0;" @click="showMenu = false">
      </div>

      <!-- Header-Zeile: Burger | Logo | Button -->
      <div class="d-flex align-items-center">
        <!-- Burger links -->
        <div style="width: 40px; flex-shrink: 0;" @click="showMenu = !showMenu">
          <i v-if="!showMenu" class="tim-icons icon-align-center cursor-pointer" style="font-size: 21px; color: white"></i>
          <i v-else class="tim-icons icon-align-left-2 cursor-pointer" style="font-size: 21px; color: white"></i>
        </div>

        <!-- Logo -->
        <div class="custom-logo-mobile flex-grow-1 text-center" @click="showMenu = false">
          <nuxt-link class="navbar-brand logo-mobile mb-0" rel="home" to="/#start" title="DATENBANKGESTALTER.DE">
            <img src="/img/mydb_logo.png">
          </nuxt-link>
        </div>

        <!-- Anmelden / Avatar rechts.
             d-flex + align-items-center analog zum Desktop-Container in
             MainNav.vue — ohne das landet AccountIcon (BaseDropdown rendert
             als <li>) in einem nicht-flex Parent und wird in der Mobile-
             Ansicht visuell weggebrochen (Avatar erscheint nicht). -->
        <div class="d-flex align-items-center" style="flex-shrink: 0;">
          <base-button v-if="!loggedIn" type="primary" size="sm" @click="toggleLoginModal()">Anmelden</base-button>
          <AccountIcon v-else></AccountIcon>
        </div>
      </div>

      <!-- Burger-Menu Inhalt — schiebt sich unter den Header -->
      <div v-if="showMenu" class="element-background-color padding-10 padding-bottom-25 animated"
           style="width: 100%; z-index: 100">
        <p @click="showMenu = false">
          <nuxt-link class="text-color-white nav-link font-weight-400 blue-font-color-by-hover" to="/#start">
            {{ $t('headerNav.start') }}</nuxt-link>
        </p>
        <p @click="showMenu = false">
          <nuxt-link class="text-color-white nav-link font-weight-400 blue-font-color-by-hover" to="/#nutzen">
            {{ $t('headerNav.benefit') }}
          </nuxt-link>
        </p>
        <p @click="showMenu = false">
          <nuxt-link class="text-color-white nav-link font-weight-400 blue-font-color-by-hover" to="/#datenbanken">
            {{ $t('headerNav.content') }}
          </nuxt-link>
        </p>
        <p @click="showMenu = false">
          <nuxt-link class="text-color-white nav-link font-weight-400 blue-font-color-by-hover" to="/#einzelpersonen">
            {{ $t('headerNav.agents') }}
          </nuxt-link>
        </p>
        <p @click="showMenu = false">
          <nuxt-link class="text-color-white nav-link font-weight-400 blue-font-color-by-hover" to="/#unternehmen">
            {{ $t('headerNav.companies') }}
          </nuxt-link>
        </p>
        <p @click="showMenu = false">
          <nuxt-link class="text-color-white nav-link font-weight-400 blue-font-color-by-hover" to="/#geschichte">
            {{ $t('headerNav.history') }}
          </nuxt-link>
        </p>
      </div>
    </div>


    <!-- Footer -->
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <div class="content">
          <slot />
        </div>

        <footer class="container footer">
          <div class="col-12 text-center">
            <div class="container-fluid">
              <nav>
                <ul class="nav justify-content-center">
                  <li class="nav-item">
                    <nuxt-link to="/impressum" rel="noopener" class="nav-link">
                      {{ $t('footerNav.imprint') }}
                    </nuxt-link>
                  </li>
                  <p class="nav-item nav-link-color-stripe no-pointer ">|</p>
                  <li class="nav-item">
                    <nuxt-link to="/datenschutzbestimmungen" rel="noopener" class="nav-link">
                      {{ $t('footerNav.data') }}
                    </nuxt-link>
                  </li>
                  <p class="nav-item nav-link-color-stripe no-pointer">|</p>
                  <!--                  <li class="nav-item">-->
                  <!--                    <nuxt-link to="/nutzungsbedingungen" rel="noopener" class="nav-link">-->
                  <!--                      {{ $t('footerNav.terms') }}-->
                  <!--                    </nuxt-link>-->
                  <!--                  </li>-->
                  <!--                  <p class="nav-item nav-link-color-stripe no-pointer">|</p>-->
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" @click=" downloadTerms()">
                      {{ $t('footerNav.gtc') }}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </footer>

        <MyDbLogInModal :login-screen="showLoginDialog" v-on:closed=" toggleLoginModal()"></MyDbLogInModal>
      </div>
    </div>


  </div>
</template>
<script lang="ts" setup>
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import { handleFileDownload } from "~/modules/common/services/util/util";
  import { ApplicationScope } from '~/api-client';

  definePageMeta({
    middleware: ['router-auth']
  });

  const { data, signIn, status } = useAuth();
  const router = useRouter();

  const { $backendService, $logger, $tenant } = useNuxtApp();

  const loggedIn = computed(() => {
    return status.value === 'authenticated' && data.value?.error === undefined;
  })


  const showMenu = ref(false);
  const pageClass = ref('login-page');
  const showLoginDialog = ref(false);


  const downloadTerms = () => {
    $backendService.termsConditionsControllerApi.getCurrentTermsAndConditions({ xApplicationScope: ApplicationScope.MyDb }).then(response => {
      handleFileDownload(response, 'agb.pdf');
    }).catch(error => {
      $logger.error('unable to download terms', error);
      ElMessage.error("Beim Herunterladen ist ein Fehler aufgetreten");
    })
  }
  const toggleLoginModal = async () => {
    // this.showLoginDialog = !this.showLoginDialog;
    await signIn('keycloak', { callbackUrl: '/dashboard/aktuelles' });
  }

</script>
<style lang="scss">
  .navbar.auth-navbar {
    top: 0;
  }

  @media (max-width: 600px) {
    .logo-mobile {
      margin-right: -25px !important;
    }
  }
</style>
